import { invokeApi } from "../../bl_libs/invokeApi";

export const live_stream_by_module_id_api = async (module_id) => {
  const requestObj = {
    path: `api/live_stream/get/${module_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_stream_detail = async (stream_id) => {
  const requestObj = {
    path: `api/live_stream/live_stream_details/${stream_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const get_participant_list_by_module_id_api = async (
  module_id,
  page,
  limit,
  search_text
) => {
  const requestObj = {
    path: `api/live_stream/get_participant_list/${module_id}?page=${page}&limit=${limit}&search_text=${search_text}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const record_media_stream_api = async (data) => {
  const requestObj = {
    path: `api/stream`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const live_meeting_by_module_id_api = async (module_id) => {
  const requestObj = {
    path: `api/meeting/meeting_detail/${module_id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};
